// ── Roles ─────────────────────────────────────────────────────────────────────
export const Role = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN:       'Admin',
  GSM:         'General Sales Manager',
  DSM:         'District Sales Manager',
  ASM:         'Account Sales Manager',
  SA:          'Sales Activator',
  ST:          'Sales Trainee',
};

// ── Statuses ──────────────────────────────────────────────────────────────────
export const Status = {
  PENDING:       'Pending',
  ASSIGNED:      'Assigned',
  COMPLETED:     'Completed',
  NOT_COMPLETED: 'Not Completed',
  CANCELLED:     'Cancelled',
};

// ── Brand Colors ──────────────────────────────────────────────────────────────
export const Color = {
  // Primary
  RED:        '#CC0033',
  NAVY:       '#0F0069',
  YELLOW:     '#FFBE00',
  GRAY:       '#999999',
  // Secondary
  LIGHT_BLUE: '#0099CC',
  LIGHT_GRAY: '#CCCCCC',
  DARK_GRAY:  '#666666',
  // Status
  GREEN:      '#008000',
  WHITE:      '#FFFFFF',
};

// ── Status Colors ─────────────────────────────────────────────────────────────
export const StatusColor = {
  [Status.PENDING]:       { bg: '#FFF8E1', text: '#B38600', dot: Color.YELLOW },
  [Status.ASSIGNED]:      { bg: '#E3F4FB', text: '#0077A3', dot: Color.LIGHT_BLUE },
  [Status.COMPLETED]:     { bg: '#E8F5E9', text: '#005700', dot: Color.GREEN },
  [Status.NOT_COMPLETED]: { bg: '#FDECEA', text: '#A00028', dot: Color.RED },
  [Status.CANCELLED]:     { bg: '#F5F5F5', text: '#666666', dot: Color.GRAY },
};

// ── Role Colors (sidebar badges) ──────────────────────────────────────────────
export const RoleColor = {
  [Role.SUPER_ADMIN]: { bg: '#FDE8EC', text: Color.RED },
  [Role.ADMIN]:       { bg: '#FDE8EC', text: Color.RED },
  [Role.GSM]:         { bg: '#E8F5E9', text: '#005700' },
  [Role.DSM]:         { bg: '#EDE7F6', text: '#4A148C' },
  [Role.ASM]:         { bg: '#E3F4FB', text: '#0077A3' },
  [Role.SA]:          { bg: '#FFF8E1', text: '#B38600' },
  [Role.ST]:          { bg: '#FFF3E0', text: '#E65100' },
};

// ── Permission helpers ────────────────────────────────────────────────────────
export const CREATOR_ROLES = [
  Role.SUPER_ADMIN, Role.GSM, Role.DSM, Role.ASM, Role.SA,
];

export const MANAGER_ROLES = [
  Role.SUPER_ADMIN, Role.GSM, Role.DSM,
];

export const ADMIN_PANEL_ROLES = [
  Role.SUPER_ADMIN, Role.ADMIN, Role.GSM,
];

// Field staff — real people on a route in a warehouse. Their contact details,
// warehouse and manager are mandatory.
export const FIELD_STAFF_ROLES = [Role.ASM, Role.ST];

// Roles that oversee every warehouse — their staff record carries no region
export const REGIONLESS_ROLES = [
  Role.SUPER_ADMIN, Role.GSM, Role.ADMIN,
];

export const EXPORT_ROLES = [
  Role.SUPER_ADMIN, Role.ADMIN, Role.GSM, Role.DSM, Role.ASM,
];

export const DASHBOARD_ROLES = [
  Role.SUPER_ADMIN, Role.ADMIN,
  Role.GSM, Role.DSM, Role.ASM, Role.ST,
];

export const COOLER_CATEGORIES = ['Cooler Pickup', 'Cooler Delivery'];

// ── View toggle modes ─────────────────────────────────────────────────────────
export const ViewMode = {
  DEFAULT: 'default',
  TEAM:    'team',
  REGION:  'region',
};

// ── Routes (React Router paths) ───────────────────────────────────────────────
export const Path = {
  LOGIN:          '/login',
  DASHBOARD:      '/',
  WORK_ORDERS:    '/work-orders',
  CREATE_ORDER:   '/work-orders/new',
  ORDER_DETAIL:   '/work-orders/:id',
  ADMIN:          '/admin',
  SYSTEM_LOGS:    '/admin/logs',
};